<div class="form-check radio-custom mb-1">
	<label class="form-check-label" [for]="id" [ngClass]="{ 'is-invalid': isInvalid(control) }">
		<input class="form-check-input" [formControl]="control" type="radio" [name]="name" [id]="id" [value]="value" />
		<span class="radio-icon-wrapper">
			<i class="checkbox-icon"></i>
		</span>
		{{ label }}
	</label>
	<div *ngIf="isInvalid(control)" class="invalid-feedback">
		<small *ngIf="inputErrors(control, 'required')">
			<span>{{ 'error.required' | translate: { fieldName: label ? label : placeholder } }}</span>
		</small>
	</div>
</div>
